import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, normalizeHttpError, Occ, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { User } from '../../../profile/root';
import { UserAccountAdapter, USER_ACCOUNT_NORMALIZER } from '../../core';

@Injectable()
export class OccUserAccountAdapter implements UserAccountAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {}

  load(): Observable<User> {
    const url = this.occEndpoints.buildUrl('user');

    return this.http.get<Occ.User>(url).pipe(
      catchError((error) => throwError(() => normalizeHttpError(error))),
      this.converter.pipeable(USER_ACCOUNT_NORMALIZER),
    );
  }
}
